import { getRequestUrl, Request } from "../../request";
import { getURL } from "../../utils";

export const get_credit = (data) => {
  return Request.get(
    getRequestUrl(getURL("/api/corporation-pa/accounts/company-employee-credits/"), data)
  );
};

export const export_credit_excel = (data) => {
  return Request.rawGet(
    getRequestUrl(getURL("/api/corporation-pa/accounts/company-employee-credits/"), data)
  );
};

export const add_credit = (data) => {
  return Request.post(
    getURL(`/api/corporation-pa/accounts/company-employee-credits/`),
    data
  );
};
